module.exports = __webpack_public_path__ + "images/icon-link.17095605578f7696a702.svg";